module.exports = __webpack_public_path__ + "img/payangel_logo.3dc0c2f5.png";